/**
 * Tedarikçi carisi ve belge isteğinin e-posta bildirimleri (ADR 0119 Ek 2026-10-24). Anahtarlar
 * `supplierNotices.*`; worker `@felix/ui/supplier-notices` ile aynı sözlükten okur. E-postada tutar,
 * IBAN, fatura ya da sipariş numarası yoktur: yalnız "portalda yeni kayıt var" ve bağlantı.
 */
export const supplierNoticesEn = {
  portalBrand: 'Felixmate · Supplier Portal',
  officeBrand: 'Felixmate',
  privacy: 'For your security this e-mail has no amounts or bank details. Sign in to see them.',
  ignore: 'If you do not use the Supplier Portal, you can ignore this e-mail.',
  invoiceReviewed: {
    subject: 'An invoice was reviewed in the Supplier Portal',
    body: 'A customer reviewed an invoice you submitted. Sign in to the Supplier Portal to see the decision.',
    action: 'Open statement',
  },
  paymentApproved: {
    subject: 'A payment was recorded in the Supplier Portal',
    body: 'A customer recorded a payment to you. Sign in to the Supplier Portal to see it in your statement.',
    action: 'Open statement',
  },
  documentRequested: {
    subject: 'Documents requested in the Supplier Portal',
    body: 'The Felixmate platform asked you for company documents. Sign in to the Supplier Portal and upload them under Company › Documents.',
    action: 'Open company documents',
  },
  invoiceSubmitted: {
    subject: 'New supplier invoice to review',
    body: 'A supplier submitted a new invoice in the Supplier Portal. Open the supplier account in Felixmate to review it.',
    action: 'Open supplier account',
  },
};

export const supplierNoticesTr: typeof supplierNoticesEn = {
  portalBrand: 'Felixmate · Tedarikçi Portalı',
  officeBrand: 'Felixmate',
  privacy:
    'Güvenliğiniz için bu e-postada tutar ya da banka bilgisi yoktur. Görmek için giriş yapın.',
  ignore: 'Tedarikçi Portalı’nı kullanmıyorsanız bu e-postayı yok sayabilirsiniz.',
  invoiceReviewed: {
    subject: 'Tedarikçi Portalı’nda bir faturanız incelendi',
    body: 'Bir müşteriniz gönderdiğiniz bir faturayı inceledi. Kararı görmek için Tedarikçi Portalı’na giriş yapın.',
    action: 'Ekstreyi aç',
  },
  paymentApproved: {
    subject: 'Tedarikçi Portalı’nda bir ödeme kaydedildi',
    body: 'Bir müşteriniz size bir ödeme kaydetti. Ekstrenizde görmek için Tedarikçi Portalı’na giriş yapın.',
    action: 'Ekstreyi aç',
  },
  documentRequested: {
    subject: 'Tedarikçi Portalı’nda belge istendi',
    body: 'Felixmate platformu sizden şirket belgeleri istedi. Tedarikçi Portalı’na giriş yapıp Şirket › Belgeler bölümünden yükleyin.',
    action: 'Şirket belgelerini aç',
  },
  invoiceSubmitted: {
    subject: 'İncelenecek yeni tedarikçi faturası',
    body: 'Bir tedarikçi Tedarikçi Portalı’ndan yeni bir fatura gönderdi. İncelemek için Felixmate’da tedarikçinin carisini açın.',
    action: 'Tedarikçi carisini aç',
  },
};
